import * as React from "react";
import { usaStates } from "../../addressData/usaStates";
import { addressCountries } from "../../addressData/countries";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpAutoComplete } from "../../../gvc/testNewForm/CpAutoComplete";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { CpInput } from "../../../gvc/testNewForm/CpInput";

interface Props {}
export const AccountCreateAddress: React.FC<Props> = ({}) => {
  const country = useCpFormValue(`address.country`);

  return (
    <div>
      <CpFormItem>
        <CpLabel name={`address.address1`}>Address Line 1</CpLabel>
        <CpInput name={`address.address1`} />
        <CpErrorWarning name={`address.address1`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`address.address2`}>Address Line 2</CpLabel>
        <CpInput name={`address.address2`} />
        <CpErrorWarning name={`address.address2`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`address.city`}>City</CpLabel>
        <CpInput name={`address.city`} />
        <CpErrorWarning name={`address.city`} />
      </CpFormItem>
      {country === "United States" ? (
        <CpFormItem>
          <CpLabel name={`address.state`}>State</CpLabel>
          <CpAutoComplete
            name={`address.state`}
            options={usaStates.map((v) => ({ label: v, value: v }))}
            filterOption={(inputValue, option) =>
              (option as any).value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
            }
          />
          <CpErrorWarning name={`address.state`} />
        </CpFormItem>
      ) : (
        <CpFormItem>
          <CpLabel name={`address.state`}>State</CpLabel>
          <CpInput name={`address.state`} />
          <CpErrorWarning name={`address.state`} />
        </CpFormItem>
      )}
      <CpFormItem>
        <CpLabel name={`address.postalCode`}>Postal Code</CpLabel>
        <CpInput name={`address.postalCode`} />
        <CpErrorWarning name={`address.postalCode`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`address.country`}>Country</CpLabel>
        <CpAutoComplete
          name={`address.country`}
          options={addressCountries.map((v) => ({ label: v, value: v }))}
          filterOption={(inputValue, option) =>
            (option as any).value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
        />
        <CpErrorWarning name={`address.country`} />
      </CpFormItem>
    </div>
  );
};
